// extracted by mini-css-extract-plugin
module.exports = {"headerWrapper":"roles-list_headerWrapper__NJvhl","tabsWrapper":"roles-list_tabsWrapper__2EaML"};